const STUDENT_PREVIEW_KEY = "memoire_student_preview";

export const isStudentPreview = () => localStorage.getItem(STUDENT_PREVIEW_KEY) === "true";

export const startStudentPreview = () => localStorage.setItem(STUDENT_PREVIEW_KEY, "true");

export const stopStudentPreview = () => localStorage.removeItem(STUDENT_PREVIEW_KEY);
